import data from './pcdf_mobile.json';

/**
 * data from the pcdf.json, object 391 in pcdf spec
 */
export interface StorageHeatersPcdbData994 {
    id: string,
    mfcRefNo: string,
    status: string,
    brandName: string,
    modelName: string,
    modelQualifier: string,
    mfcFirstYear: string,
    mfcFinalYear: string,
    capacity: string,
    outputPower: string,
    boostOutput: string,
    heatRetention: string,
    highHeatRetention: string
}

export interface StorageHeatersPcdb994 {
    data: {
      391: StorageHeatersPcdbData994[];
    };
  }
  
export const rdsapStorageHeatersPcdbData994 = data as StorageHeatersPcdb994;
